module.exports = __webpack_public_path__ + "static/media/ic-alert.ce589575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/ic-alert.svg
// module id = 926
// module chunks = 0